<template>
	<div class="campoVerMais">
		<span
			v-if="textoTruncado"
			id="textoTruncado"
			:inner-html.prop="
				transformarCaractereEspecialEmEntidade(texto)
					| azClipText(tamanhoMaximo)
					| destacarPalavra(palavrasDestaque)
					| textoSemValorSimples
			"
			@click.stop="tratarEventoExpandirTexto"
		></span>
		<span
			v-else
			id="textoNormal"
			:inner-html.prop="transformarCaractereEspecialEmEntidade(texto) | destacarPalavra(palavrasDestaque) | textoSemValorSimples"
			@click.stop="tratarEventoExpandirTexto"
		></span>
		<a
			v-if="ehTextoMaiorQueTamanhoMaximo && exibirMensagemVerMaisVerMenos"
			id="linkVerMais"
			class="blue--text inline text-decoration-underline"
			@click.stop
		>
			<span @click.prevent="tratarEventoExpandirTexto">
				<span v-if="verMais" id="verMais">ver mais</span>
				<span v-else id="verMenos" class="ml-1">ver menos</span>
			</span>
		</a>

		<modal-ver-mais
			id="modalVerMais"
			:exibir="exibirModal"
			:palavras-destaque="palavrasDestaque"
			:texto="texto"
			:titulo="tituloModal"
			@fechar-modal="fecharModal"
		></modal-ver-mais>
	</div>
</template>

<script>
import destacarPalavra from "@/views/credenciamento/detalhe-credenciamento/filters/destacar-palavra";
import textoSemValorSimples from "@/views/credenciamento/detalhe-credenciamento/filters/texto-sem-valor-simples";
import ModalVerMais from "./ModalVerMais.vue";

export default {
		name: 'texto-ver-mais',
		components: { ModalVerMais },
	props: {
		exibirMensagemVerMaisVerMenos: {
			type: Boolean,
		},
		palavrasDestaque: {
			type: Array,
			default() {
				return []
			},
		},
		texto: {
			type: [String, Number, null],
			default: '',
		},
		tamanhoMaximo: {
			type: Number,
			default: 80,
		},
		verMaisModal: {
			type: Boolean,
		},
		tituloModal: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			textoTruncado: true,
			verMais: true,
			exibirModal: false,
		}
	},
	computed: {
		textoSeguro() {
			return this.texto == null ? '' : String(this.texto)
		},
		ehTextoMaiorQueTamanhoMaximo() {
			return this.textoSeguro.length > this.tamanhoMaximo
		},
	},
	filters: {
		destacarPalavra,
		textoSemValorSimples,
	},
	methods: {
		transformarCaractereEspecialEmEntidade(valor) {
			return valor == null ? '' : String(valor)
		},
		abrirModal() {
			if (this.verMaisModal) {
				this.exibirModal = true
			}
		},
		fecharModal() {
			this.exibirModal = false
		},
		tratarEventoExpandirTexto() {
			if (this.verMaisModal) {
				this.abrirModal()
				return
			}

			if (this.verMais) {
				this.tratarEventoVerMais()
			} else {
				this.tratarEventoVerMenos()
			}
		},
		tratarEventoVerMais() {
			this.textoTruncado = false
			this.verMais = false
		},
		tratarEventoVerMenos() {
			this.textoTruncado = true
			this.verMais = true
		},
	},
}
</script>
